var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorssLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 36h36V0H0v36z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.25 0 0 -1.25 0 45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 0H4c4 0 3 9 3 9 0 2.209 1.791 15 4 15h21s4 0 4-4V3s0-3-3-3",
    fill: "#99aab5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 3c0-3 3-3 3-3H3S0 0 0 4v28a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V3z",
    fill: "#ccd6dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1M27 20a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1M27 24a1 1 0 0 0-1-1h-8a1 1 0 1 0 0 2h8a1 1 0 0 0 1-1M27 12a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1M27 8a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1M27 4a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1M25 27s2 0 2 2v2s0 2-2 2H5s-2 0-2-2v-2s0-2 2-2h20z",
    fill: "#99aab5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15s2 0 2 2v6s0 2-2 2H5s-2 0-2-2v-6s0-2 2-2h8z",
    fill: "#55acee"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorssLogo);
export default __webpack_public_path__ + "static/media/monitorss-logo.ab98090f1def9186417bd476bb0eda93.svg";
export { ForwardRef as ReactComponent };